import { useState } from 'react';

import { TimeSlot } from '../../../state/infiniteCalendarSeries';
import { getOverallDiscount } from './utils';

export const useTab = (timeSlotData: TimeSlot[]) => {
    const [activeTab, setActiveTab] = useState<string | null>(null);

    return {
        activeTab,
        setActiveTab,
        overallDiscount: getOverallDiscount(timeSlotData),
    };
};
